import { render, staticRenderFns } from "./CreateCarriageContract.vue?vue&type=template&id=061279a2&"
import script from "./CreateCarriageContract.vue?vue&type=script&lang=js&"
export * from "./CreateCarriageContract.vue?vue&type=script&lang=js&"
import style0 from "./CreateCarriageContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports